import React from "react";
import { createStyles, WithStyles, withStyles, Theme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { FiniteStateMachineObject } from "figma-fsm/lib/transformations/transformCanvasToFiniteStateMachine";
import Highlight from "react-highlight";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

export interface MachineStyleProps extends WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    machine: {
      position: "relative",
      padding: "24px",
      margin: "12px 0",
      [theme.breakpoints.up("md")]: {
        margin: "0 12px"
      }
    },
    copyButton: {
      marginTop: "12px"
    }
  });

interface MachineProps {
  machineObject: FiniteStateMachineObject;
}

const copyToClipboard = (str: string) => {
  const el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};

const Machine = ({ classes, machineObject }: MachineStyleProps & MachineProps) => {
  const machineText = `const machine = Machine(${JSON.stringify(machineObject, null, 1)});`;
  const handleCopy = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.preventDefault();
    copyToClipboard(machineText);
  };

  return (
    <>
      <Paper className={classes.machine}>
        <Typography variant="h6">{`Prototype: ${machineObject.id}`}</Typography>
        <Button
          className={classes.copyButton}
          variant="contained"
          color="secondary"
          onClick={handleCopy}
        >
          Copy to Clipboard!
        </Button>
        <Highlight className="javascript">{machineText}</Highlight>
      </Paper>
    </>
  );
};

export default withStyles(styles)(Machine);
